import { ConcreteEncodable } from "./ConcreteEncodable";

import { UserVisibilityProfileImplEncoder } from "../../encoder/UserVisibilityProfileImplEncoder";

import * as CubiqTS from "../../index";
import { UserVisibilityProfile } from "../UserVisibilityProfile";

export class UserVisibilityProfileImpl extends ConcreteEncodable implements UserVisibilityProfile {
  public static enType: string = "com.bcdfx.model.UserVisibilityProfileImpl";

  /*FID=1*/
  public userId: CubiqTS.Long | null = null;
  /*FID=2*/
  public visibilityProfileType: CubiqTS.VisibilityProfileType;
  /*FID=3*/
  public userVisibilityRules: Array<CubiqTS.UserVisibilityRule> | null = null;
  /*FID=4*/
  public profileId: CubiqTS.Long | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = UserVisibilityProfileImplEncoder.Instance;
    this.setEncodableType(UserVisibilityProfileImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "UserVisibilityProfileImpl[" +
      "userId=" +
      this.userId +
      "visibilityProfileType=" +
      this.visibilityProfileType +
      "userVisibilityRules=" +
      this.userVisibilityRules +
      "profileId=" +
      this.profileId +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
